import React from "react";
import { NavLink, useNavigate } from "react-router-dom";

import {
  LayoutDashboard,
  CalendarDays,
  Scissors,
  Tag,
  BookOpen,
  Sparkles,
  LogOut,
  Menu,
  X,
  
} from "lucide-react";
import "../../assets/css/layout/admin/AdminSidebar.css";

const SGC_NAV_ITEMS = [
  {
    items: [
      { to: "/admin/dashboard",    icon: LayoutDashboard, text: "Dashboard" },
      { to: "/admin/subadmins",    icon: LayoutDashboard, text: "Sub Admins" },
      { to: "/admin/categories",    icon: LayoutDashboard, text: "Categories" },
      { to: "/admin/treatments",   icon: Scissors,        text: "Treatments" },
       
      
      { to: "/admin/appointments", icon: CalendarDays,    text: "Appointments" },
      { to: "/admin/deals",        icon: Tag,             text: "Deals" },
      { to: "/admin/blogs",        icon: BookOpen,        text: "Blogs" },
      { to: "/admin/ai-content",   icon: Sparkles,        text: "AI Content" },
      { to: "/admin/support",      icon: Sparkles,        text: "Support" },
    ],
  },
];

const SGCSidebar = ({ open, onClose }) => {
  const navigate = useNavigate();

  // ✅ Logout Handler
  const handleLogout = () => {
    localStorage.removeItem("adminEmail");
    localStorage.removeItem("adminData");
      localStorage.removeItem("adminPassword");
    navigate("/adminlogin");
  };

  return (
    <>
      {/* Mobile Toggle */}
      <button
        className="sgc-sidebar__toggle"
        aria-label="Toggle sidebar"
        onClick={onClose}
      >
        {open ? <X size={18} /> : <Menu size={18} />}
      </button>

      {/* Overlay */}
      <div
        className={`sgc-sidebar__overlay ${open ? "active" : ""}`}
        onClick={onClose}
      />

      {/* Sidebar */}
      <aside className={`sgc-sidebar ${open ? "open" : ""}`}>
        {/* Brand */}
        <NavLink to="/" className="sgc-sidebar__brand">
          <div className="sgc-sidebar__brand-avatar">E</div>
          <div className="sgc-sidebar__brand-info">
            <span className="sgc-sidebar__brand-name">Estetica Skin&amp;Laser</span>
            <span className="sgc-sidebar__brand-role">Admin</span>
          </div>
        </NavLink>

        {/* Navigation */}
        <nav className="sgc-sidebar__nav">
          {SGC_NAV_ITEMS.map((group, gi) => (
            <div key={gi}>
              <ul className="sgc-sidebar__nav-list">
                {group.items.map(({ to, icon: Icon, text }, idx) => (
                  <li
                    key={to}
                    className="sgc-sidebar__nav-item"
                    style={{ animationDelay: `${idx * 60}ms` }}
                  >
                    <NavLink
                      to={to}
                      end={to === "/admin"}
                      className={({ isActive }) =>
                        `sgc-sidebar__nav-link ${isActive ? "active" : ""}`
                      }
                    >
                      <Icon className="sgc-sidebar__nav-icon" size={18} />
                      <span className="sgc-sidebar__nav-text">{text}</span>
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>

        {/* Footer — Logout Button */}
        <div className="sgc-sidebar__footer">
          <button
            onClick={handleLogout}
            className="sgc-sidebar__footer-link"
          >
            <LogOut size={18} />
            <span>Logout</span>
          </button>
        </div>
      </aside>
    </>
  );
};

export default SGCSidebar;